import PropTypes from 'prop-types';
import { elementOfType } from 'utilsTS/prop-types';

import { Switch } from 'components/Switch';

export const itemPropTypes = {
    value: PropTypes.string.isRequired,
    href: PropTypes.string,
    label: PropTypes.node,
    control: elementOfType([Switch]),
    border: PropTypes.bool,
    disabled: PropTypes.bool,
    selected: PropTypes.bool,
};

export const itemDefaultProps = {
    label: '',
    disabled: false,
};

export const sectionPropTypes = {
    section: PropTypes.string.isRequired,
    emptyLabel: PropTypes.node,
    isLoading: PropTypes.bool,
    loadingText: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape(itemPropTypes)),
};

export const valuePropTypes = PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.shape(itemPropTypes),
    PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.shape(itemPropTypes)]),
    ),
]);

export const sectionsOrItemsPropType = PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.shape(itemPropTypes), PropTypes.shape(sectionPropTypes)]),
);
